// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewerMainContainer_container__2J6xR","inner":"ViewerMainContainer_inner___EQkO"};